import { render, staticRenderFns } from "./Subscribe.vue?vue&type=template&id=50b60ff6&scoped=true&"
import script from "./Subscribe.vue?vue&type=script&lang=ts&"
export * from "./Subscribe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b60ff6",
  null
  
)

export default component.exports